import { CanActivateFn } from '@angular/router';
import { SessionService } from '../../services/session.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const authGuard: CanActivateFn = async (route, state) => {
  const sessionService = inject(SessionService);
  const router = inject(Router);
  if (sessionService.getLoggedIn() === true) {
    return true;
  } else {
    router.navigate(['/login-user']);
    return false;
  }
};
